var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "gallery grid grid__base", class: _vm.rootClasses },
    [
      _c("div", { staticClass: "gallery--container grid--container" }, [
        _c("div", { staticClass: "gallery--wrapper-row grid--row" }, [
          _c("div", { staticClass: "gallery--wrapper grid--col" }, [
            _c(
              "div",
              {
                ref: "slider",
                staticClass: "gallery--swiper-container swiper-container"
              },
              [
                _c(
                  "div",
                  { staticClass: "gallery--swiper-wrapper swiper-wrapper" },
                  _vm._l(_vm.items, function(item, idx) {
                    return _c(
                      "div",
                      {
                        key: idx,
                        staticClass: "gallery--slide swiper-slide",
                        class: _vm.slideClass
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "gallery--slide-content" },
                          [
                            _c(
                              "picture-element",
                              _vm._b(
                                { staticClass: "gallery--image" },
                                "picture-element",
                                item,
                                false
                              )
                            )
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.items.length > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "gallery--btn gallery--btn-prev",
                        class: _vm.btnPrevClass
                      },
                      [
                        _c("base-icon", {
                          attrs: { symbol: "chevron-left", size: "small" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.items.length > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "gallery--btn gallery--btn-next   ",
                        class: _vm.btnNextClass
                      },
                      [
                        _c("base-icon", {
                          attrs: { symbol: "chevron-right", size: "small" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-38ca96a1", { render: render, staticRenderFns: staticRenderFns })
  }
}